<script setup>
  import { computed } from 'vue';
  import UpgradeButton from '@/components/UpgradeButton.vue';
  import { formatMembershipLevels } from '@/utils/formatMembershipLevels';

  const props = defineProps({
    upgrade: {
      type: Array,
    required: true
    },
    showProforecastMessaging: {
      type: Boolean,
      default: false
    }
  });

  const messageText = computed(() => {
    // A nullish check on purpose: upgrade[1] is undefined for member levels
    // with no upgrade path (`undefined?.length === 0` is false, which crashed
    // formatMembershipLevels for Gold members — LIF-181 investigation).
    if (!props.upgrade[1]?.length) return `Upgrade to view this station's <strong>wind graph.</strong>`;

    return `Upgrade to <strong>${formatMembershipLevels(props.upgrade[1])}</strong> to view this station's <strong>wind graph.</strong>`;
  });

  const secondaryMessageText = computed(() => {    
    return `<strong>Pro</strong> &amp; <strong>Gold</strong> users will have access to our exclusive professional meteorologist <strong>Pro Forecast</strong> model written specifically for this station.`;
  });    

  const buttonText = computed(() => {
    if (props.upgrade[2] === null) return 'Upgrade Now';

    return props.upgrade[2] ? 'Start Free Trial' : 'Upgrade Now';
  });

</script>

<template>
  <div class="jwx-upgrade-container-wrapper">
    <div class="jwx-upgrade-container">
      <div class="jwx-upgrade-container__block"></div>
      <div class="jwx-upgrade-container__message">
        <p class="jwx-upgrade-container__text" v-html="messageText"></p>
        <p 
          v-if="props.showProforecastMessaging"
          class="jwx-upgrade-container__secondary-text"
          v-html="secondaryMessageText"
        ></p>
        <UpgradeButton :buttonText="buttonText" clickLocation="Wind Graphs Banner" />
      </div>

      <div class="jwx-upgrade-container__hero">
        <img src="../assets/images/upgrade/wind-graph-preview.webp" alt="" class="jwx-upgrade-container__hero-image" />
      </div>
      <div 
        v-if="props.showProforecastMessaging"
        class="jwx-upgrade-container__callout"
      >
        <div class="jwx-upgrade-container__callout-graphic">
          <img src="../assets/images/upgrade/wind-graph-pro-forecast-preview.webp" alt="" class="jwx-upgrade-container__callout-image" />
        </div>
        <p class="jwx-upgrade-container__callout-text">Pro Forecast Model</p>
      </div>
    </div>

    <img src="../assets/images/upgrade/wind-graph-blurred.jpg" alt="" class="jwx-upgrade-container__bg-image" />
  </div>
</template>